import { isIOS, isMobile } from 'react-device-detect'
import { LoopRepeat } from 'three'

const tempImg = () =>
  'https://picsum.photos/1200/1200?random=' + Math.round(Math.random() * 10)
// const tempPano = ()=>'https://picsum.photos/200/100?random=' + Math.round(Math.random()*10)
const tempPano = () => 'equirect-panorama.jpg'
const scale = (vec) => vec.map((x) => x * 100)
const paraFontSize = '1.5vw'
const headingFontSize = '2vw'
export const debug = false

/**
 * GA Code
 */
export const gaConfig = {
  enabled: true,
  code: 'G-GGQGKR6BTR',
}

const flattenLocations = (museums) => {
  // Flatten and add era field to location objects
  let flattenedArray = []
  for (let idx in museums) {
    //
    flattenedArray = [
      ...flattenedArray,
      ...museums[idx].locations.map((location) => ({
        ...location,
        era: museums[idx].era,
        eraText: museums[idx].text,
        eraTitle: museums[idx].title,
        eraid: idx - 1,
        eraListHeading: museums[idx].listHeading,
        eraList: museums[idx].list,
      })),
    ]
  }
  flattenedArray = flattenedArray.map((x, idx) => ({
    ...x,
    url: isMobile ? x.lr : x.hr,
    locationId: idx,
  }))
  console.log(flattenedArray)
  return flattenedArray
}

export const zindexes = {
  mangroves: 100,
  hud: 70,
  splashscreen: 90,
  valueWheel: 80,
  timelinesContainer: 75,
  timelines: 78,
}

export const springConfigs = {
  linear: {
    mass: 15.6,
    tension: 120,
    friction: 3,
    clamp: true,
    velocity: 1,
  },
  heavyLinear: {
    mass: 18.1,
    tension: 462,
    friction: 159,
    clamp: true,
    velocity: 0.1,
  },
  precision: {
    mass: 110,
    tension: 500,
    friction: 53,
    clamp: true,
  },
}
export const colorThemes = [
  '#36AA9D',
  '#754576',
  '#CE492A',
  '#3B3874',
  '#36AA9D',
] //pass in era id
export const popupColorThemes = [
  '#36AA9D',
  '#754576',
  '#CE492A',
  '#3B3874',
  '#36AA9D',
] //pass in era id
export const bgcolorThemes = [
  '#33968B',
  '#654366',
  '#A93D24',
  '#2B2852',
  '#36AA9D',
]

export const AllMuseumLocations = [
  {
    era: 'era0',
    list: '\n',
    locations: [
      {
        name: 'location0',
        hr: './Godrej_archives_360_photos/HR/0.webp',
        lr: './Godrej_archives_360_photos/LR/0.webp',
        vlr: './Godrej_archives_360_photos/VLR/0.webp',
        lookAt: [2.9984775325616577, 0.6978395656356703, -2.553434437645962],
        hotspots: [
          {
            type: 'valuewheel',
            position: [-99, -13, 6],
          },
          // {
          //     type:'timelines',

          //     position: [-104, -70, -75] ,
          //     rotation: [0.9, 0.74, 0] ,
          //     scale: 169
          // },
          {
            type: 'museum',
            position: [-227, -142, 137],
            rotation: [4.61, 0, 1.7],
            scale: 253,
          },
        ],
      },
    ],
  },
  {
    eraid: 0,
    era: '1897-1940',
    title: 'A NEW NATION',
    text: 'The spirit of Swadeshi was flowing. But there was more to Swadeshi than the political protest of boycotting foreign goods. One man, especially, believed passionately that without economic independence, political freedom would mean nothing. Ardeshir B. Godrej chose to act upon his belief with intellect, innovation and vision.',
    listHeading: 'Pre Independence',
    list: "Introduction\nThe sturdy little lock\nGuardian of the nation's wealth\nThe soap story",
    locations: [
      {
        name: 'Introduction',
        lookAt: [2.96, -0.064, -2.67],
        hr: './Godrej_archives_360_photos/HR/1.webp',
        lr: './Godrej_archives_360_photos/LR/1.webp',
        vlr: './Godrej_archives_360_photos/VLR/1.webp',
        map: ['20%', '20%'],
        hotspots: [
          {
            type: 'era',
            text: 'To 1940',
            era: 1,
            position: [32, -76, 169],
            rotation: [4.52, 0, 3.96],
            scale: 103,
          },

          {
            type: 'location',
            number: 2,
            position: [30, -52, 96],
            rotation: [4.67, 0, 2.3],
            scale: 70,
          },
          {
            type: 'location',
            number: 3,
            position: [159, -98, 80],
            rotation: [4.57, 6.28, 5.49],
            scale: 100,
          },
          {
            position: [-295, 18, -9],
            type: 'textheavy',
            url: './content/era1/interview.jpg',
            imagetype: 'portrait',
            title: 'A RESTLESSNESS TO BE SELF RELIANT',
            text: 'The spirit of Swadeshi was flowing. It had become a true non-violent weapon of nationalism. But there was more to Swadeshi than the political protest of boycotting foreign goods. One man, especially, believed passionately that without economic independence, political freedom would mean nothing. Ardeshir B. Godrej chose to act upon his belief with intellect, innovation and vision. A newspaper report stating that burglaries were on the rise in the city of Bombay prompted him to start with the manufacturing of locks, a humble yet crucial product required by the common Indian. \n Inspired by the thoughts of nationalist leaders and progressive thinkers, especially Dadabhai Naoroji, Ardeshir, as a step towards fueling ‘economic independence of India’, reigned in the traditional expertise of the artisans from Gujarat and Malabar and also deployed modern manufacturing techniques in his factory. And so, in a time when expensive imported goods were flooding the Indian markets, he proved that self-reliance in the manufacturing field was the way forward. ',
            subtext: 'Interview with Ardeshir B. Godrej ',
            subsubtext:
              'Indian Herald, 27 Apr 1927\nCentenary Collection ACCN: MS06-01-94-1',
          },
          {
            position: [90, 40, 300],
            type: 'comic',
            url: './content/era1/AR1.webp',
          },

          {
            position: [-164, 45, 300],
            type: 'collage',
            url: './content/era1/5BPanel.png',
          },

          {
            position: [-400, -19, 215],
            type: 'comic',
            url: './content/era1/Long1.png',
            title: "OBJECTS OF MR.GODREJ'S DONATION",
            text: 'Newspaper article reporting that Ardeshir Godrej donated Rupees Three Lakhs to Tilak Swaraj Fund initiated by Mahatma Gandhi in 1921',
            subsubtext:
              '\n Bombay Chronicle, 11 July 1921,  \n Centenary Collection \n ACCN: MS06-01-94-77',
          },
          {
            position: [-400, 97, 306],
            type: 'comic',
            url: './content/era1/Long2.png',
            title: 'A TRIUMPH FOR SWADESHI VENTURE',
            text: 'Newspaper article stating how Godrej safes replaced European safes in the Indian Postal Department',
            subsubtext:
              '\n Bombay Chronicle, 23 Aug 1928,  \n ACCN: MS09-33-1-1',
          },
        ],
      },
      {
        name: 'The sturdy little lock',
        hr: './Godrej_archives_360_photos/HR/2.webp',
        lr: './Godrej_archives_360_photos/LR/2.webp',
        vlr: './Godrej_archives_360_photos/VLR/2.webp',
        lookAt: [3.073, 1.571, -2.02],
        map: ['20%', '30%'],
        hotspots: [
          {
            type: 'textheavy',
            url: './content/era1/lockdisplay.jpg',
            title: 'THE STURDY LITTLE LOCK',
            text: 'At the foundation of the wide inventory of products, was the small, sturdy, nearly unbreakable lock. Taking cues from the traditional lock makers of Malabar and Gujarat, Godrej mechanised the process of making locks so thoroughly, that theirs acquired the reputation of being virtually unpickable, even with the cunning skills of local lock-pickers.',
            subtext:
              '“... so staggering is the figure of possible combinations of this lock that burglars may fiddle with it for months without the hope of hitting upon the right combination”',
            subsubtext:
              '“Manufacture of security equipment in our country:\nOne field in which we are self-sufficient” - \nS P Godrej,\nThe Times of India,1958',
            position: [-360, -278, -142],
          },
          {
            type: 'era',
            text: 'To 1940',
            era: 1,
            position: [50, -105, 106],
            rotation: [4.86, 0, 4.26],
            scale: 154,
          },

          {
            type: 'location',
            number: 1,
            position: [-59, -92, -94],
            rotation: [4.67, 0, 1.5],
            scale: 100,
          },
          {
            type: 'location',
            number: 3,
            position: [66, -79, -79],
            rotation: [1.47, 0, 0.57],
            scale: 70,
          },

          {
            type: 'object',
            name: 'navtal',
            position: [-300, -300, -27],
            title: 'ROUND NAVTAL',
            text: 'Since its introduction in 1958, the Nav-Tal has been guarding Indian homes and is considered synonymous with trust, protection and integrity. So popular were these locks that they gave rise to a parallel industry which flooded the market with inferior imitations. But the original just could not be matched. The first Nav-Tal padlocks from 1950s were square in shape and it was only in July 1960 that Nav-Tal got its iconic round shape. Whether the motive behind this was aesthetic, economic or utilitarian remains elusive though.',
            url: './videos/pano-002_min.mp4',
          },
          {
            type: 'object',
            name: 'squarelock',
            title: 'SQUARE NAVTAL',
            text: 'The Godrej NAV-TAL Padlock enjoys an enviable market reputation. Its unique synthesis of robustness, reliability, elegance and of course economy, with its precision 7 lever mechanism as its USP makes it enviable. However, did you know that before the round one, there was a square version of this sturdy beauty? Archival documents show that Godrej began manufacturing the square Nav-Tal range in 1958. While we had known of the square version of the lock from the documents, we couldn’t seem to get our hands on a specimen. In November 2019, we received a box full of locks from all over the world and lo and behold, amongst them was the elusive square Godrej NAV-TAL Padlock!',
            position: [-300, -224, 68],
          },

          {
            type: 'comic',
            url: './content/era1/LockPatent.webp',
            title: 'THE LOCK PATENT',
            text: 'First patent for Godrej received by Pirojsha Godrej from King Edward VII for the manufacture of springless locks, 1908',
            subsubtext: '\n ACCN: MS06-01-94-73',
            position: [-400, -108, 26],
          },

          {
            type: 'video',
            position: [-230, -124, 299],
            title: 'LOCKS MANUFACTURING', //Locks manufacturing clip_trial_0
            text: 'Clipping from ‘The Godrej Story’, first corporate film of Godrej released in 1969.\nACCN: AV10-01-11-11',
            url: 'https://vimeo.com/655248700/c97474271b',
          },
        ],
      },
      {
        name: 'Soaps & Safes',
        lookAt: [0.173, -0.167, -3.993],
        hr: './Godrej_archives_360_photos/HR/3.webp',
        lr: './Godrej_archives_360_photos/LR/3.webp',
        vlr: './Godrej_archives_360_photos/VLR/3.webp',
        map: ['30%', '20%'],
        hotspots: [
          {
            type: 'comic', // the line one
            url: './content/era1/soaptimeline.png', //Need to add some gap between the text and the image
            name: 'soapline',
            title: 'THE SOAP STORY',
            text: 'Here’s a timeline of Godrej soaps introduced over the years.',
            position: [198, -135, 269],
          },

          {
            type: 'era',
            text: 'To 1940',
            era: 1,
            position: [-14, -103, -168],
            rotation: [5.03, 6.42, 1.47],
            scale: 154,
          },

          {
            type: 'location',
            number: 1,
            position: [134, -81, -9],
            rotation: [4.69, 0, 4.86],
            scale: 100,
          },
          {
            type: 'location',
            number: 2,
            position: [60, -85, -120],
            rotation: [4.69, 0, 5.11],
            scale: 100,
          },

          {
            type: 'comic', // comic
            url: './content/era1/AR2.webp',
            position: [-142, 46, -300],
            name: 'refrigerator',
          },
          {
            type: 'comic',
            url: './content/era1/HomeSavingSafes.webp',
            title: 'HOME SAVINGS SAFE',
            text: "The compact Home Savings Safe, introduced by Godrej in the 1930s, was sized like a small piggy bank, and was perfect for some small savings that would go a long way. It boasted of an impeccably scratch-proof and permanent finish, courtesy of the best cellulose automobile enamel that could withstand the corrosion caused by the country's tropical climate.",
            subsubtext: 'Circa 1940, \nACCN: MB06-01-47-38 ',
            position: [-400, -55, -44],
          },

          {
            type: 'video',
            position: [-400, -99, 240],
            title: 'NAVGANIS', //On_the_Move_Godrej_Archives_Final
            url: 'https://vimeo.com/655248744/6cbb5216b3',
            text: 'On the Move: Memories of Movement and Migration with the Navganis of Phadalewadi, June 2019',
          },
          {
            type: 'video',
            position: [-271, 12, -215],
            title: 'BOMBAY DOCKS EXPLOSION', //bombay_docks_explosion_trial,
            url: 'https://vimeo.com/655248548/3da3358e9b',
            text: 'Clipping from ‘The Godrej Story’, first corporate film of Godrej released in 1969. \n ACCN: AV10-01-11-11 ',
          },

          {
            type: 'collage',
            position: [232, 154, 400],
            url: './content/era1/SoapsScroll.png',
          },
          {
            type: 'collage',
            position: [-400, 104, 309],
            url: './content/era1/SafesScroll.png',
          },

          // {
          //     type:'landscape',
          //     url:'./content/era1/Safes9.webp',
          //     title:'',
          //     text:'',
          //     subtext:'Article',
          //     subsubtext:'Bombay',
          // },

          {
            position: [-132, 32, 400],
            type: 'audio',
            url: './content/era1/ManiThakurInterview.mp3',
            title: "Mani Thakur's Interview",
            text: 'Mrs. Thakur not only holds the title of first lady employee but also the first lady salesperson of the New Delhi branch. Listen to Mrs. Thakur talk about her experience of being the only woman employee in the 1950s.',
            subsubtext: 'OH08059',
          },

          {
            type: 'textheavy',
            url: './content/era1/test/',
            video: false,
            url: './content/era1/ManiThakur.webp',
            imagetype: 'square',
            title: 'MRS. MANI THAKUR',
            text: 'We met Mrs. Mani Thakur née Sorabji of Delhi branch in 2008 for interviewing her - the first lady employee and the first lady salesperson of the Branch. She joined the company in 1956 as receptionist cum secretary to the then Branch Manager – Dr. K R Hathi. \n Her responsibilities included attending phone calls and managing Dr. Hathi’s correspondence. Being the first and only female employee in the branch was not exactly a cake walk. For starters, the branch office had only one common washroom! But a far graver problem posed itself at the time when Mani, now Mrs. Thakur, was expecting her first child. Much to her embarrassment, she approached Dr Hathi to enquire about maternity leave rules. A perplexed Dr. Hathi, sought clarification from General Manager Mr. N D Sahukar in Bombay via an urgent letter. But as luck would have it, no one had a clue! What followed was a series of lengthy visits made to the Delhi Labour Court to understand rules regarding Maternity Benefits! \n As the years went by, gradually more and more women were employed. But Mrs. Thakur once again surprised one and all when she opted for a sales profile in the late 1960s. Around this time Godrej Bhavan (Delhi) - the massive new office in Okhla - was ready and all functions, except the showroom, shifted out of the old office at Aruna Asaf Ali Rd. to Okhla. Unwilling to travel to far away Okhla, Mrs. Thakur decided to take the plunge into Sales and assisting Showroom in-charge Mr. Beri. One wonders if Sales was tough for her – hitherto a receptionist. “No!” She clarifies - “I had sales experience on telephone… It (Sales) was a matter of how you talk. Besides, when I first joined Godrej, Dr. Hathi handed over a copy of every product catalogue and asked me to learn its features by heart. \n Dr. Hathi, a very strict manager, believed that a receptionist/ telephone operator should have complete product knowledge to tackle both curious and irate customers. He often caught Mrs. Thakur completely off-guard by quizzing her at random about different products or their features. This thorough training under Dr. Hathi prepared her for her future role as Store-in-chief, a responsibility she carried out with élan till her retirement in 1991.',
            subtext:
              'Mrs. Mani Thakur, the first woman employee appointed in Godrej’s Delhi branch office at Asaf Ali Road, 1956',
            subsubtext: 'Courtesy: Mani Thakur\nACCN: PH08-22-1-1',
            position: [-147, 46, 326],
          },
          {
            type: 'textheavy',
            url: './content/era1/Soaps2.webp',
            title: 'Vatni advertisement with Madhubala',
            text: "Godrej launched a soap named 'Vatni' in 1938, derived from the name 'Vatan' meaning country or motherland. In 1938, when the world was on the brink of Second World War, and as the British government paid more attention to war efforts in Europe, when the freedom struggle in India was becoming fierce, it was an apt move to choose a name with Swadeshi roots. The soap wrapper even carried the image of an undivided India like it was before Independence. \nSurprisingly, it continued to be produced even after independence with the same packaging design. And we came to know that because of an interesting discovery made in the recent past. We learnt that a famous actress of Hindi cinema, the ever-beautiful and charming Madhubala endorsed the soap 'Vatni' in 1956, when we stumbled upon this wonderful advertisement poster during one of our trips to Chor Bazaar in Mumbai. Literally translating to ‘Thieves Market’, Chor Bazaar is now a shopping hub for vintage items and antiques. Towards the bottom of the advertisement, in small lettering, it says 'You'll shortly be seeing Madhubala in RAJ HATH', a Hindi movie that was released in 1956, placing the advertisement too around the same time period. ",
            subtext:
              'Vatni soap advertisement featuring popular actress Madhubala',
            subsubtext: 'Circa 1956, ACCN: MS17-13-3-1',
            position: [27, 200, 337],
          },
          {
            type: 'textheavy',
            url: './content/era1/Letter.webp',
            title: 'A letter from Ardeshir Godrej',
            text: 'Here’s a handwritten letter in Gujarati from Ardeshir Godrej to Mulchand Shah, enquiring about the prices of vegetable oils used in soap making. This letter is special from an archival as well aesthetic point of view as the letterhead featured a beautifully designed range of Godrej soaps and soap boxes!',
            subtext: '14th March 1932',
            subsubtext: 'ACCN: MS11-72-44-4 ',
            position: [-169, 162, 400],
          },
          {
            type: 'textheavy',
            url: './content/era1/CurrencyNote.jpg',
            title: 'THE CURRENCY NOTE THAT SURVIVED A BLAST',
            text: 'The Bombay Docks explosion of 1944 is an unfortunate event in the history of the city. \n On 14th April 1944, when the S.S. Fort Stikine stationed in the Victoria Docks and laden with ammunitions and explosives exploded, it caused a blazing inferno, that reduced the other ships in the docks to scrap iron and set warehouses and offices in the vicinity on fire that raged on for days. Hundreds lost their lives. \n This also came as a supreme test for the Godrej safes housed in offices nearby. After the safes were recovered from the debris, they were found to be battered and discoloured on the outside but with all the contents inside intact. These specimens of currency notes saved by the Godrej safes were retained and framed by an employee at the Lalbaug factory of Godrej to save it for posterity as a hallmark of reliability of Godrej safes.',
            subtext: '',
            subsubtext: 'ACCN: MB19-25-43-32 ',
            position: [-400, -37, -175],
          },
        ],
      },
    ],
  },
  {
    eraid: 1,
    era: '1940-1970',

    title: 'ENGINEERING NATION BUILDING',
    text: 'The metaphor of the indigenously produced humble lock expanded into a guiding philosophy of quality, durability and inventiveness for the company. With this came modern ideas of management including employee welfare and upliftment, leading to greater productivity and happier, healthier workplace.',
    listHeading: 'A New India',
    list: 'Introduction & Product wall\nThe many first-ever products by Godrej',
    locations: [
      {
        name: 'Introduction & Product wall',
        hr: './Godrej_archives_360_photos/HR/7A-Closed.webp',
        lr: './Godrej_archives_360_photos/LR/7A-Closed.webp',
        vlr: './Godrej_archives_360_photos/VLR/7A-Closed.webp',
        lookAt: [9.647, 1.613, 2.059],
        hotspots: [
          {
            type: 'era',
            text: 'To 1897',
            era: 0,
            position: [-12, -76, 112],
            rotation: [4.52, 0, 5.34],
            scale: 95,
          },
          {
            type: 'era',
            text: 'To 1940',
            era: 2,
            position: [22, -76, -151],
            rotation: [4.8, 0, 0.85],
            scale: 100,
          },

          {
            type: 'location',
            number: 2,
            position: [7, -82, -116],
            rotation: [4.69, 0, 4.75],
            scale: 100,
          },
          {
            type: 'location',
            number: 3,
            position: [44, -109, -400],
            rotation: [1.67, 0, 2.58],
            scale: 130,
          },

          {
            type: 'object',
            name: 'ballot',
            title: 'BALLOT BOX',
            text: 'Godrej & Boyce supplied 12.83 lakh steel ballot boxes for the first General Elections of India in 1952, by manufacturing around 15,000 ballot boxes a day on an average in less than four months without affecting normal production! \n Countless deliberations and more than 50 specimens later, a design by Nathalal Panchal, a workman at Godrej, was finalized. He had devised a unique locking system that could only be opened by breaking a pre-impressed insignia and manipulating the locking lever through the aperture covered by the insignia. This eliminated the need for an external lock, making these sturdy, reusable, tamperproof, rot and vermin proof ballot boxes available for only Rs. 5/- each. \n The ballot boxes were transported to remote corners of 23 states in India, from the Vikhroli railway station through commercial and passenger train wagons, earning them the sobriquet ‘election specials’. ',
            position: [-379, -115, 7],
          },
          {
            type: 'object',
            name: 'typewriter',
            title: 'TYPEWRITER',
            text: 'Making a typewriter is as intricate as making a watch, with 1800 parts to fit together and complex functionalities to perfect. Yet, in 1955, Godrej produced India’s first indigenous typing machine, a pioneering accomplishment of national self-reliance and progress. And shortly in another innovative coup, they presented keyboards in Indian languages.',
            position: [-400, -121, -202],
          },

          {
            position: [-400, -198, -38],
            type: 'audio',
            url: './content/era2/MrThanewallaBallot.mp3',
            title: "Kershed Thanewalla's Interview",
            text: 'Listen to K R Thanewalla, Manager of Plant 1, reminiscing the excitement of manufacturing ballot boxes in 1951 for independent India’s first general elections that were held in 1952.',
            subsubtext: 'OH06002',
          },
          {
            type: 'textheavy',
            video: false,
            url: './content/era2/EngNationBldg.webp',
            imagetype: 'square',
            title: 'ENGINEERING NATION BUILDING',
            text: 'The metaphor of the indigenously produced humble lock expanded into a guiding philosophy of quality, durability and inventiveness for the company. With this came modern ideas of management including employee welfare and upliftment, leading to greater productivity and happier, healthier workplaces.',
            subtext:
              'A special supplement brought out by Godrej in all leading newspapers at the launch of the first Typewriter made by Godrej, 1955',
            subsubtext: 'Centenary Collection, ACCN: MS06-01-94-80',
            position: [300, 65, -80],
          },
          {
            type: 'textheavy',
            video: true,
            url: './content/era2/GodrejTownshipVikhroli1.mp4',
            imagetype: 'square',
            title: 'A NEW INDIA',
            text: 'Without loud proclamations of patriotism, Godrej quietly played a supporting role in free India’s first elections. The factories churned out 15,000 ballot boxes a day to fulfill the order of 12 lakh boxes given by the Election Commission. \n Innovation was in the air. A flurry of fresh products were designed using mechanized processes, in keeping with the excitement of a newly independent India. India’s first home refrigerator, its first homegrown typewriter, the first indigenous forklift, steel racks and shelves for libraries and institutions. Godrej’s first factory outside India, in Malaysia, ‘manned’ mostly by women. It was a season of firsts. \n Vikhroli was an emblem of all that was progressive in Godrej. An industrial township that ensured a good life for workers, professionalism and efficiency of processes at brand new plants using technology to mass produce without compromising quality, and the preservation of the natural beauty of the mangroves which were a unique feature of this land. Godrej’s products, from security gadgets, furniture, hospital and railway equipment, to their soaps like Cinthol, came to be seen as the necessary companions of the rising middle class of a rapidly developing nation.',
            subtext: '',
            subsubtext: '',
            position: [124, 63, -307],
          },
          {
            type: 'textheavy',
            video: false,
            url: './content/era2/printblocksafe.jpeg',
            imagetype: 'square',
            title: 'PRINTING BLOCKS',
            text: 'Before the modern innovations of offset printing and digital printing happened, printing using wooden blocks was a very common method of printing. Godrej too used the same at times for printing advertisements for its products in newspapers and magazines.  \n As Godrej Archives explored through records at defunct Lalbaug factory in 2006, many such wooden printing blocks were found carrying advertisements of different Godrej products in various languages. ',
            subtext: 'Printing block of safes used for printing advertisements',
            subsubtext: 'Circa 1965, Lalbaug Survey \n ACCN: MB19-25-43-27',
            position: [-400, -17, -285],
          },
          {
            type: 'textheavy',
            video: false,
            url: './content/era2/Visadex.jpg',
            imagetype: 'square',
            title: 'VISADEX',
            text: 'Record keeping has always been important to organizations. Traditionally, before the advent of computers, records were mostly on paper and such files were manually maintained. \n The VISADEX was launched by Godrej & Boyce in the 1940s to simplify filing and records keeping. As the name suggests, it offered a visible indexing system by which records were kept on specially designed cards with movable coloured signs to show the relative progress and position of the vital items on the card. Initially, there were two models; one with 6 and the other with 12 drawers and each drawer has a card-holder tray that could hold 40 to 55 cards. Later, in the 70s, 4 new models were introduced. \n The VISADEX was widely used to control stocks, purchase, production, sales, advertising, accounts, personnel etc. and was the pride of offices and libraries until the 1980s before computers became prominent. ',
            subtext: '',
            subsubtext: 'ACCN: MB19-22-16-1',
            position: [-366, -200, 232],
          },
          {
            type: 'collage',
            position: [-400, -21, 69],
            url: './content/era2/ProductsScrollABallot.png',
          },
          {
            type: 'collage',
            position: [-317, 56, -77],
            url: './content/era2/ProductsScrollATypewriter.png',
          },
        ],
      },

      {
        name: 'The many first-ever products by Godrej',
        hr: './Godrej_archives_360_photos/HR/7B-Closed.webp',
        lr: './Godrej_archives_360_photos/LR/7B-Closed.webp',
        vlr: './Godrej_archives_360_photos/VLR/7B-Closed.webp',
        map: ['50%', '50%'],
        lookAt: [12.196, 1.519, 1.35],
        hotspots: [
          {
            type: 'era',
            text: 'To 1897',
            era: 0,
            position: [-21, -71, 199],
            rotation: [5.57, 3.08, 1.98],
            scale: 110,
          },
          {
            type: 'era',
            text: 'To 1940',
            era: 2,
            position: [23, -71, 2],
            rotation: [1.39, 2.8, 2.63],
            scale: 90,
          },

          {
            type: 'location',
            number: 1,
            position: [-11, -79, 137],
            rotation: [1.47, 0, 4.58],
            scale: 100,
          },
          {
            type: 'location',
            number: 3,
            position: [13, -79, -104],
            rotation: [1.47, 0, 6.05],
            scale: 100,
          },

          {
            type: 'object',
            name: 'refrigerator',
            title: 'REFRIGERATORS',
            text: 'For the first time, Indian families could acquire a refrigerator that fit neatly into their homes, at an affordable price from a brand they already trusted. Mass production and mechanization had helped Godrej introduce products of international quality to Indian markets. The middle class was delighted. ',
            position: [-400, -26, -400],
          },

          {
            type: 'textheavy',
            video: false,
            url: './content/era2/MalaysiaFac.webp',
            imagetype: 'square',
            title: 'WOMEN IN MALAYSIA FACTORY',
            text: 'In the year 1967, Godrej & Boyce made its first foray into the international scene with its maiden venture in Malaysia. Mr. Thanewalla, who was responsible for setting up the factory in Malaysia, says the experience was both challenging and fun. One fine day, a Frenchman, Mr. Rene of the Fiat manufacturing unit in the neighbourhood, recommended Mr. Thanewalla to employ women as he had come to know of Malay women as hardworking. Upon Mr. Rene’s recommendation, Mr. Thanewalla decided to expand the workforce to the Malay women. \n In one of his oral history interviews, Mr. Thanewalla vividly recalls his encounter with a Malay woman at the Godrej Malaysia factory that reinforced his faith in his decision to employ women, “I had a girl in Malaysia who could beat all men in productivity and production... in everything. She used to work the machines; not just one machine - she used to work on bending machines, punching machine, circular saw... everything. She could set the dies, set the tools herself and learnt to drive the fork lift truck”.',
            subtext:
              'Women employed at Godrej Malaysia -Godrej’s first overseas plant',
            subsubtext:
              'Circa 1972, Source: Mitter Bedi Collection \n ACCN: PH06-01-96-90 ',
            position: [288, 14, 400],
          },

          {
            type: 'comic', // comic
            url: './content/era2/AR3.png',
            position: [-253, 80, -400],
            name: 'refrigerator',
          },

          {
            type: 'collage',
            position: [-400, -30, -191],
            url: './content/era2/CataloguesScroll.png',
          },

          {
            type: 'video',
            position: [-400, 1, 198],
            title: 'FORKLIFT', //Godrej Forklift_trial_0
            url: 'https://vimeo.com/655248622/7c0ecbbb47',
            text: 'Clipping from ‘The Godrej Story’, first corporate film of Godrej released in 1969. \n ACCN: AV10-01-11-11',
          },

          {
            type: 'collage',
            position: [-400, 44, 22],
            url: './content/era2/ProductsScrollB.png',
          },
        ],
      },
      {
        name: 'videobooth',
        hr: './Godrej_archives_360_photos/HR/7B-Closed.webp',
        lr: './Godrej_archives_360_photos/LR/7B-Closed.webp',
        vlr: './Godrej_archives_360_photos/VLR/7B-Closed.webp',
        hotspots: [],
      },
    ],
  },
  {
    eraid: 2,
    era: '1943-1970 ',
    title: 'A GODREJ TOWNSHIP: VIKHROLI',
    text: 'A small village nestled in vast tracts of mangroves, due east of Mumbai, became a symbol of manufacturing integrity, employee emancipation and environmental sustainability. This was Vikhroli, where the industrial township of Pirojshanagar was created by Godrej.  ',
    listHeading: 'Vikhroli',
    list: 'The beginnings\nWelfare\nMangroves',
    locations: [
      {
        name: 'The beginnings',
        hr: './Godrej_archives_360_photos/HR/8.webp',
        lr: './Godrej_archives_360_photos/LR/8.webp',
        vlr: './Godrej_archives_360_photos/VLR/8.webp',
        lookAt: [9.851, 0.528, -1.635],
        hotspots: [
          {
            type: 'era',
            text: 'To 1940',
            era: 1,
            position: [-17, -71, -82],
            rotation: [4.8, 0, 2.94],
            scale: 90,
          },
          {
            type: 'era',
            text: 'To 1970',
            era: 3,
            position: [17, -71, -156],
            rotation: [4.8, 0, 0.12],
            scale: 90,
          },

          {
            type: 'location',
            number: 2,
            position: [-66, -55, 109],
            rotation: [1.51, 3.02, 0],
            scale: 80,
          },
          {
            type: 'location',
            number: 3,
            position: [75, -79, -92],
            rotation: [1.47, 0, 6.92],
            scale: 90,
          },

          {
            type: 'comic',
            url: './content/era3/VikhroliBrochure.webp',
            name: '',
            title: 'A GODREJ TOWNSHIP: VIKHROLI',
            text: 'A small village nestled in vast tracts of mangroves, due east of Mumbai, became a symbol of manufacturing integrity, employee emancipation and environmental sustainability. This was Vikhroli, where the industrial township of Pirojshanagar was created by Godrej. There were 5 factory areas where products like steel cupboards, tables and chairs, steel windows and more were produced on a mass scale. \n Long before labour laws were enacted by the government, Pirojsha Godrej was giving employee and retirement benefits to his people. Along with this, they were given clean, solid housing and the wonderful environs of the township. A dispensary provided free medicines. Free schooling for children at the progressive Udayachal School changed attitudes and futures.',
            subtext:
              'Brochure of planned Godrej Industrial Township at Vikhroli',
            subsubtext:
              'February 1959, Centenary \nCollection\nACCN: MS06-01-94-94',
            position: [-400, 63, 191],
          },

          {
            type: 'textheavy',
            video: true,
            url: './content/era3/GodrejTownshipVikhroli2.mp4',
            imagetype: 'square',
            title: 'A GODREJ TOWNSHIP: VIKHROLI',
            text: 'Old timers tell tales of the transformation of the land from wilderness to development, and photos and yellowed documents reveal the impact of that transformation on the history of the company, and indirectly of the country as well.\n "Vikhroli was still a tiny village sparsely populated, surrounded by rice fields, with a range of hills to the west, beyond which lay Powai Lake. To the east, the village was fringed by tidal swamps with bright green bushes of mangroves and salt-water channels from the Thane Creek".\n <em> ‘Times bring Change\' in a \'Symbiosis of Industry and Nature: Flora and Fauna of Pirojshanagar, An Eastern Suburb of Mumbai’, Soonabai Pirojsha Godrej Foundation and Bombay Natural History Society, 2000, p. Xvii  </em>',
            subtext: '',
            subsubtext: '',
            position: [-400, 77, -204],
          },
          {
            type: 'textheavy',
            video: true,
            url: './content/era3/Station1.mp4',
            station: 1,
            imagetype: 'square',
            title: 'STATION NO 1 : THE VIKHROLI TOWNSHIP',
            text: 'At Vikhroli, Godrej created a unique industrial township, Pirojshanagar, with plants for mass manufacture of products as well as housing, schools, dipensaries and community welfare spaces for workers and their families. \n A small village nestled in vast tracts of mangroves, due east of Mumbai, became a symbol of manufacturing integrity. This was Vikhroli, where the industrial township of Pirojshanagar was created by Godrej. There were factory areas in which products like steel cupboards, tables and chairs, steel windows and more were produced on a mass scale. Old timers tell tales of the transformation of the land from wilderness to development, and photos and yellowed documents reveal the impact of that transformation on the history of the company, and indirectly of the country as well. \n “Vikhroli was still a tiny village sparsely populated, surrounded by rice fields, with a range of hills to the west, beyond which lay Pawai Lake. To the east, the village was fringed by tidal swamps with bright green bushes of mangroves and salt-water channels from the Thane creek.” \n <em> ‘Times bring change’ in “A Symbiosis of Industry and Nature: Flora and Fauna of Pirojshanagar, An Eastern Suburb of Mumbai, Soonabai Pirojsha Godrej Foundation and Bombay Natural History Society, 2000, p.Xvii </em> \n Long before labour laws were enacted by the government, Pirojsha Godrej was giving employee and retirement benefits to his people. Along with this, they were given clean, solid housing and the wonderful environs of the township. A dispensary provided free medicines. Free schooling for children at the progressive Udayachal School changed attitudes and futures. ',
            subtext: '',
            subsubtext: '',
            position: [160, -54, -400],
          },
          {
            type: 'textheavy',
            video: true,
            url: './content/era3/Station2.mp4',
            station: 2,
            imagetype: 'square',
            title: 'STATION NO 2 : PLANT 13-18',
            text: "Initially, Plants 13 to 18 were meant to be Plants 6 to 11. However, Plants 6 to 12 ended up being built on the western side, and these were re-numbered. They were constructed in the following order — Plant 13, followed by Plant 18 and then 17, 16, 15 and 14. All the plant constructions were under the supervision of the architects K N Katrak or B N Sethna. As Godrej was involved with the Indian Machine Tools Exhibition (IMTEX) at the same time, the newest plants were used to host IMTEX, before manufacturing began in them. \n <b> Plant 13 </b> Earlier named Plant 6, Plant 13 was originally completed in 1964 to house the foundry, which used to be in the old Lalbaug factory. Between 1970 and 1980, several structural changes and extensions were made to the foundry building. In 1990 after the foundry had closed down, Plant 13 was made ready for the manufacture of Storwel cupboards. Mr. M H Engineer remembers a time when Plant 13 was the only building on the eastern side of the campus. The rest of the property still had paddy fields, which were cultivated by farmers every monsoon! \n <b> Plant 14 </b> Covering an area of 29,840sq.m, this was the last plant to be built in this series. The proposal for the building was submitted in 1977. Once it was completed, the manufacture of chairs moved from Plant 4 to here. \n <b> Plant 15 </b> Plant 15 was built for the Process Equipment Division (PED), which was the forerunner to Godrej Aerospace. \n <b> Plant 16 </b> The original plan for Plant 16 was approved in 1969. Between 1975 and 1980, several bays were added to the plant. After it was built, the manufacture of Godrej's forklift trucks moved to this plant from Plant 10. In 1985, a further office and factory section was applied for. Plant 16 and 17 were the location of the 1979 Indian Machine Tools Exhibition (IMTEX). \n <b> Plant 17 </b> The construction of this plant, then proposed as the 'Tube Mill', commenced in 1970. Built after Plant 18, Plant 17 was allotted for the Security Solutions Division (SSD), which was also earlier in Plant 2A. Today the SSD still occupies Plant 17. \n <b> Plant 18 </b> Records mention that when Plant 18 was first proposed in 1968, it was intended for Construction and Auto Repair. Work began after the license was provided in 1974. Eventually, it was called the Process Equipment Division (PED). After a few years in Plant 18, PED moved to the newly built Plant 15. After that the Locks division moved from its former home in Plant 8 to Plant 18, where it is even today. ",
            subtext: '',
            subsubtext: '',
            position: [154, -38, 1],
          },
          {
            type: 'textheavy',
            video: true,
            url: './content/era3/Station3.mp4',
            station: 3,
            imagetype: 'square',
            title: ['STATION NO 3 : PLANT 1', 'STATION NO 3 : PLANT 4'],
            text: [
              "Construction began in 1948, soon after land was bought in Vikhroli. Set in what then seemed like the middle of nowhere, the imposing Plant 1, built in 1951, marked the beginning of the Godrej Industrial Township. Mr. Thanewalla, the first Plant Manager of Plant 1 recalls, \"In May 1951, I was sent to Vikhroli. There were no plants there. Only Plant 1... and those days were great fun. There was no transport so we had to walk to the station and back. And there also I did lot of night shifts. And at night we (used to) light those mashals and with the mashal and my bhaiyya walking in front of me I used to walk from the railway tracks up to the Vikhroli station. It was great fun.\"  \n Mr. Thanewalla was also in charge of the plant's first assignment — manufacturing ballot boxes for independent India's first elections. The ballot box, rolled out in huge numbers daily, had been produced after meticulous research. Here is Mr. Thanewalla's memory of the time. \"I think I don't know finally how many ballot boxes we ended up making — about 15 or 17 lacs and at our best I think we were producing 22 thousand ballot boxes per day. And Pirojsha Godrej [would] promptly [be] there at 3 o'clock every afternoon asking us how it is going. And he got orders from other companies who had not somehow or the other managed to make them. See, these ballot boxes not only have to be watertight but airtight... because if they were air tight then they would be water tight. So the testing meant putting 10 pounds of pressure inside each ballot box. The mechanism  was tested. Every box has to be tested. 'Kadak' if it closes and 'kadak' it should open. Once it is closed, without putting your finger inside and opening the string you cannot unlock it. That's it.\" \n After ballot boxes, Godrej’s Storwel cupboards were produced in the plant until 1972, when Storwel production moved to Plant 12. Today, the plant hosts the Godrej Electricals and Electronics (E&E), providers of solution technology in energy and environment related issues to companies across India and other parts of the world. The Central Stationery and Stores, also located in this plant, contain personnel files of former employees (Note: Amanda Engineer's father's file was procured from here), and other records related to the business that are currently still in use. Also in this plant are the safety department and the control room of campus security.",
              'One of Godrej’s areas of expertise, especially from the 1950s to the 70s, was tubular steel furniture, and it was Plant 4 that saw all the action. Foldable chairs, tables, centerpieces, sofas and beds rolled out of this plant. Today the plant houses the sales office of Godrej’s Mumbai branch. ',
            ],
            subtext: '',
            subsubtext: '',
            position: [400, -25, 253],
          },
          {
            type: 'textheavy',
            video: true,
            url: './content/era3/Station4.mp4',
            station: 4,
            imagetype: 'square',
            title: ['STATION NO 4 : PLANT 2 & 5', 'STATION NO 4 : PLANT 3 & 6'],
            text: [
              'Godrej refrigerators, launched in 1958, were manufactured in this plant, the second to come up in Vikhroli. As the business expanded, Plant 2 and Plant 5 jointly produced refrigerators, with conveyor belts running between the two buildings. Windows, manufactured in Plant 2 along with other furniture like tables, racks, tubes and chairs, were a part of the company\'s brief foray into architectural fabrication. \n "At its peak in the 1960s and 70s, Godrej’s aluminum frames and steel windows were supplied for prestigious constructions all over the country, and beyond. Within Mumbai, Godrej’s architectural fabrications could be seen on many buildings such as the Tata Institute of Fundamental Research (TIFR), Larsen & Toubro, Hotel Palm Grove, and Breach Candy Hospital, among others. Frames and windows made by Godrej have also played an active but uncelebrated role in the changing skyline of 1970s Mumbai, especially in the high-rise offices of Nariman Point, an iconic and well-known waterfront facade of the city." (from the Archives Times, Apr-May 2014) \n The manufacture of refrigerators moved to the town of Mohali in 1996. Just prior to its demolition, Plant 2 had housed a small repository of Godrej Archives. Today, the structure of Plant 2 has been replaced by that of the Business Park, which is home to offices of several other companies.',
              'Typewriters were first produced by Godrej in 1955. After being on the anvil since 1947, the launch of the Godrej all-Indian typewriter was greeted with much fanfare, affirmation of independent India\'s capabilities. When it was time to shift the manufacture of typewriters from the old Lalbaug factory to Vikhroli, it was set up briefly in Plant 1A, and then went to Plant 3 in 1967. In 1985, the manufacture of typewriters moved to Plant 6, where it remained until the operations shifted to Shirwal in 2002. \n A permanent fixture of Plant 3 was the canteen, a trend carried over from the Lalbaug factory. Taking care to provide subsidized and nutritious breakfasts and meals to the factory workers in particular, it was a feat of hard work and planning. Recalls D D Amrute, Canteen Head, "... seating capacity was 3000. It was that big... At that time there was nothing like night shift and all... So the cook used to come at 4 o\'clock and keep the vadas ready. By 6 o\'clock everything used to be out and they were giving fresh jalebis early in the morning, batata vadas, samosas and then bajiyas, then sheera, then there were boiled eggs, sandwiches, omelettes, everything was there. So many items together." \n The canteen also rose to the occasion to serve dishes from several cuisines to participants of the Indian Machine Tools Exhibitions (IMTEX), which were held in Godrej through the 1970s and 80s. Says D D Amrute, "I had all technical knowledge but to organize such a big event right from planning to the exhibition, then you formulate your processes, systems and that also keeping this thing running all the time, the big canteen — is not a joke. 9000-10000 people\'s catering.... the first assignment was a success and from then no looking back."',
            ],
            subtext: '',
            subsubtext: '',
            position: [400, 16, 305],
          },
          // ['STATION NO 3 : PLANT 1','STATION NO 3 : PLANT 4'],
          {
            position: [164, -113, -400],
            type: 'audio',
            url: './content/era3/MrBajiMistry.mp3',
            title: "Baji Mistry's Interview",
            text: 'Baji Mistry has left everlasting impression on the Godrej Locks Division since 1958. Listen to Mr. Mistry remember the hectic days when the company was moving its base from Lalbaug to Vikhroli.',
            subsubtext: 'OH06013',
          },
          {
            position: [400, -78, 293],
            type: 'audio',
            url: './content/era3/MrThanewalla.mp3',
            title: "Kershed Thanewalla's Interview",
            text: 'Listen to Mr. K. Thanewalla recalling some of his earliest adventures in Vikhroli in the 1950s while he was working as a plant manager at Plant 1.',
            subsubtext: 'OH06002',
          },
          {
            position: [-363, -107, -400],
            type: 'audio',
            url: './content/era3/MrKolhatkar.mp3',
            title: "Kolhatkar's Interview",
            text: 'Mr. Kolhatkar’s association with Godrej typewriter manufacturing is decades long. Listen to Mr. Kolhatkar’s first impression of the Pirojshanagar, when he first visited the plant as young man to seek a job at Godrej in 1970.',
            subsubtext: 'OH08026',
          },
        ],
      },

      {
        name: 'Welfare',
        hr: './Godrej_archives_360_photos/HR/10B.webp',
        lr: './Godrej_archives_360_photos/LR/10B.webp',
        vlr: './Godrej_archives_360_photos/VLR/10B.webp',
        lookAt: [9.908, -0.075, -1.344],
        hotspots: [
          {
            type: 'textheavy',
            video: true,
            url: './content/era3/Udhyachal_comp.mp4',
            imagetype: 'square',
            title: 'Udayachal School – a beacon of progressive learning!',
            text: 'Setting up a progressive school for children of Godrej employees was a crucial part of Pirojsha Godrej’s larger vision of social welfare and development of Vikhroli township. Established in 1955 as Balak Mandir, the Udayachal Schools, literally meaning ‘the eastern mountain from where the sun rises’, believe in providing a holistic learning environment which nurtures independent thinkers. Experiential learning, the playway method and thematic learning were implemented actively since the inception and gradually, games, activities, exhibitions, fieldtrips, music & dance, etc. became the norm in the way children of Godrejites were educated.',
            // subtext:'‘Times bring Change in a Symbiosis of Industry and Nature:  Flora and Fauna of Pirojshanagar, An Eastern Suburb of Mumbai’, Soonabai Pirojsha Godrej Foundation and Bombay Natural History Society',
            // subsubtext:'',
            position: [-400, 75, 11],
          },
          {
            type: 'era',
            text: 'To 1940',
            era: 1,
            position: [-41, -116, -274],
            rotation: [4.83, 0, 2.71],
            scale: 194,
          },
          {
            type: 'era',
            text: 'To 1970',
            era: 3,
            position: [394, -116, -271],
            rotation: [4.72, 0, 1.05],
            scale: 275,
          },

          {
            type: 'location',
            number: 1,
            position: [-4, -52, -115],
            rotation: [4.69, 0, 0],
            scale: 80,
          },
          {
            type: 'location',
            number: 3,
            position: [144, -52, -170],
            rotation: [4.69, 5.99, 4.75],
            scale: 100,
          },

          {
            type: 'textheavy',
            video: true,
            url: './content/era3/era3Video.mp4',
            imagetype: 'square',
            title: 'A SPACE TO GROW : PRAGATI KENDRA',
            text: 'After moving to Vikhroli, which then had little to offer in lieu of the conveniences of the city, Pirojsha Godrej was concerned about the education and well-being of employees’ families. So, on 15th August 1955, the Pragati Kendra was set up in the Godrej Township under the watchful eye of Soonuben and Jaiben Godrej. \n Workers’ education programmes and literacy classes opened up worlds for people in the township. The community space facilitated lectures and symposiums on various topics including family planning, hygiene and nutrition. Sports and cultural facilities brought people together and gave them an outlet after work.',
            subtext: '',
            subsubtext: '',
            position: [-358, 200, 400],
          },

          {
            position: [-220, -86, 400],
            type: 'audio',
            url: './content/era3/Alooben.wav',
            title: "Alooben Mowdawalla's Interview",
            text: 'Ms. Alooben Mowdawalla joined Godrej in the 1950s as its first Welfare Officer. Listen to Ms. Mowdawalla’s experience of working with the community and developing Pragati Kendra, a welfare center established in 1955.',
            subsubtext: 'OH06005',
          },
          {
            position: [-400, -10, 92],
            type: 'audio',
            url: './content/era3/Ramesh.mp3',
            title: "Ramesh Bhandarkar's Interview",
            text: 'Listen to Mr. Bhandarkar from Godrej Construction recall the good old days of the Godrej colony, where the community stood with each other through thick and thin.',
            subsubtext: 'OH10009',
          },
          {
            position: [-400, 42, -85],
            type: 'audio',
            url: './content/era3/MrsSharadaben.mp3',
            title: "Sharadaben Panchal's Interview",
            text: 'Sharadaben Panchal, an alumni and former teacher of Udayachal High School recalls her vivid childhood memories of growing up in Pirojshanagar.',
            subsubtext: 'OH10008',
          },
          {
            position: [-400, -8, -231],
            type: 'audio',
            url: './content/era3/DrPA.Joshi.mp3',
            title: "Dr. P A Joshi's Interview",
            text: 'During Dr. P A Joshi’s long and fulfilling career as an engineer-cum-designer at Godrej, he and his family resided at the Godrej Hillside Colony. Listen to Dr. Joshi’s experiencing of living in the cradle of nature at Godrej Hill where everyone lived like one big family!',
            subsubtext: 'OH08027',
          },
          {
            type: 'textheavy',
            video: true,
            url: './content/era3/Station5.mp4',
            station: 5,
            imagetype: 'square',
            title: ['STATION NO 5 : PLANT 7 (1a)', 'STATION NO 5 : PLANT 8'],
            text: [
              "Plant 7 (1A), built as a small annexe to Plant 1, briefly saw the manufacture of typewriters, which was then moved to Plant 3. Renamed as Plant 7 in 1972, this plant has long been home to the Tool Room (now Godrej Tooling). Integral to the development of many Godrej divisions, the Tool Room was established in 1935, under the initiative of Naval Godrej, who had then just joined the factory. With a keen eye and a knack for machinery, he felt that the company would benefit from machines, rather than purchasing them. Initially serving internal needs, the Tool Room began to cater to the needs of other businesses, eventually leading to the foundation of Godrej's foray into space in the 1980s.",
              "When the locks division moved from Lalbaug to Vikhroli, Plant 2A began the manufacture of locks. Locks, Godrej's first product manufactured in 1897, have always held a special place in the company. It was in Plant 2A that Godrej's most popular lock, Navtal, was manufactured in 1954. Renamed Plant 8 in 1972, it now houses Godrej Aerospace (formerly known as Precision Component Systems). Started tentatively as a part of the Tool Room, Godrej Aerospace soon grew to match the expectations of clients like the Indian Space Research Organization (ISRO). ",
            ],
            subtext: '',
            subsubtext: '',
            position: [400, 6, -393],
          },
          {
            type: 'textheavy',
            video: true,
            url: './content/era3/Station6.mp4',
            station: 6,
            imagetype: 'square',
            title: [
              'STATION NO 6 : PLANT 9 (3a)',
              'STATION NO 6 : PLANT 10',
              'STATION NO 6 : pLANT 11',
            ],
            text: [
              "A plant that handled the assembling of machine tools, was where India's first indigenous forklift trucks were manufactured in 1961. Before 1972, the company's senior management had their offices in this plant. Today, Plant 9 hosts Godrej Precision Engineering Systems, which manufactures defence equipment, wind turbines generator parts and other precision engineering services.",
              'Set up in 1972, Plant 10 was dedicated to the initial shift towards the use of computers in industry. It was then home to the Computer Services Department. Initially used for internal services, it became a separate entity in 1999.',
              'The first department to occupy the newly constructed Plant 11 was the Design Centre. Mr. P.A. Joshi, head of R&D at the Centre, recalls, "[The] Design Centre was started in 1972. The building was ready and NPG was planning to have the Design Centre there. One day, I was called by N P Godrej, who told me, \'I have made such a big plant for you. Go and see\'. So I went there and next day I told Naoroji that the space was not sufficient. He called the consultant in-charge and told him to build one more floor. It became ground plus one level. The office was on the first floor and the workshop was on the ground floor..." \n In its short lifetime, the Design Centre gained much momentum and influence, as Mr. Joshi explains, "Our Design Centre...was reinstituted as a recognized research and development center by the Government of India. And various tax concessions and incentives were made available to the company because of this recognition. Our company was represented on ISI committees. When the Design Centre was shut down, and more floors added to Plant 11, offices began to occupy them. The Sales Office of the Machine Tools division and the office of Godrej Appliances, present even today, are some examples. The plant is home to the offices of the Personnel, Administration and Finance departments. So, one hears the murmurs of voices and the beeps of telephones rather than the sonorous clanking of heavy machinery in this plant today." ',
            ],

            position: [400, -14, -225],
          },
        ],
      },
      {
        name: 'Mangroves',
        hr: './Godrej_archives_360_photos/HR/10A.webp',
        lr: './Godrej_archives_360_photos/LR/10A.webp',
        vlr: './Godrej_archives_360_photos/VLR/10A.webp',
        lookAt: [9.958, 0.0904, -0.103],
        hotspots: [
          {
            type: 'era',
            text: 'To 1940',
            era: 1,
            position: [81, -114, 104],
            rotation: [4.72, 0, 5.82],
            scale: 110,
          },
          {
            type: 'era',
            text: 'To 1970',
            era: 3,
            position: [-60, -200, 238],
            rotation: [1.1, 3.3, 0],
            scale: 265,
          },

          {
            type: 'location',
            number: 1,
            position: [105, -64, 17],
            rotation: [4.67, 0, 4.45],
            scale: 100,
          },
          {
            type: 'location',
            number: 2,
            position: [190, -54, -78],
            rotation: [4.8, 6.04, 5.33],
            scale: 100,
          },

          {
            type: 'textheavy',
            video: false,
            url: './content/era3/Mangroves1.webp',
            imagetype: 'portrait',
            title: 'MANGROVES',
            text: 'Nature was nurtured so that people got the full benefit of its munificence. The mangroves that grew bountifully in the area were protected by Soonabai Pirojsha Godrej Marine Ecology Centre, an initiative of S.P. Godrej along with eminent environmentalists like Dr. Salim Ali, Dr. Ganguly and Dr. H N Sethna. Since then, Godrej has been scientifically managing the mangroves through research, conservation and awareness. The mangroves give much in return, acting as lung space, sequestering around 50,000 tons of carbon dioxide every year and mitigating the adverse effects of climate change on the Mumbai Metropolitan Region.',
            subtext: 'Vikhroli Mangroves',
            subsubtext: '2011\nACCN: PH13-21-1-1',
            position: [-400, 121, 267],
          },
          {
            type: 'textheavy',
            video: false,
            url: './content/era3/Mangroves2.webp',
            imagetype: 'square',
            title: 'MANGROVES', //hyperlink in the 3rd line
            text: "The Vikhroli Mangroves have been part of the company’s rich heritage since the beginning. The vastness of the mangroves stretches across acres of land. 16 varieties of mangrove, 206 varieties of avians and several marine and terrestrial animals call the Vikhroli mangroves their home. \n To quote author Sharada Dwivedi, from her exemplary piece of work, 'Vikhroli – Times Bring Change’, in Godrej – A Symbiosis of Nature and Work', “Even before the factory sheds were erected, trees were planted. Over the decades, the verdant Godrej property at Vikhroli became a model for successful development. The key word with Godrej was caring - about their people, about their environment, and about the mangroves that were slowly dying in most parts of metropolitan Bombay.”",
            subtext: '',
            subsubtext: '',
            position: [-400, 60, -180],
          },
        ],
      },
    ],
  },
  {
    eraid: 3,
    era: '1970-1990',
    title: 'CHANGING SKYLINES',
    text: 'Godrej had entered the hearts and homes of the Indian middle class with its wave of popular products, adapting constantly to the desires of the consumer. The sturdy, reliable everyman’s maker of locks and cupboards morphed into an aspirational brand making deodorant soaps and washing machines, endorsed by cinema stars. ',
    listHeading: 'The modern consumer period',
    list: 'Architectural fabrications\nAerospace',
    locations: [
      {
        name: 'Architectural fabrications',
        hr: './Godrej_archives_360_photos/HR/11.webp',
        lr: './Godrej_archives_360_photos/LR/11.webp',
        vlr: './Godrej_archives_360_photos/VLR/11.webp',
        lookAt: [9.961, -0.15, -0.863],
        title: 'Esse labore amet deserunt esse ',
        text: 'Deserunt qui et est ullamco amet culpa deserunt quis. Cillum ipsum incididunt culpa est minim culpa non sit ullamco. Excepteur nulla eu amet sint. Commodo enim amet aliqua irure laborum nostrud eu dolor ipsum laborum aliquip officia laboris culpa.',
        hotspots: [
          {
            type: 'era',
            text: 'To 1940',
            era: 2,
            position: [-67, -114, 177],
            rotation: [4.8, 0, 2.97],
            scale: 145,
          },

          {
            type: 'location',
            number: 2,
            position: [30, -93, 21],
            rotation: [1.51, 3.29, 7.61],
            scale: 80,
          },

          {
            type: 'textheavy',
            video: false,
            url: './content/era4/ArchFab.webp',
            imagetype: 'portrait',
            title: 'ARCHITECTURAL FABRICATION',
            text: 'For a short period in the 1960s and 70s, Godrej entered the business of fabricating steel and aluminium products for architectural use in buildings. Many of the iconic buildings that form the instantly identifiable skyline of Mumbai have doors, windows, ventilators, frames and false ceilings manufactured by Godrej. The TIFR building, NCPA, The Oberoi Hotel and the Air India building were built with Godrej’s products. The city’s best and brightest architects were clients. Architectural fabrications were designed, built and installed in other metro cities too.',
            subtext: 'Catalogue of Architectural Fabrication',
            subsubtext:
              'Circa 1970, Lalbaug Collection \nACCN: CAT14-01-825-479',
            position: [-400, 31, 278],
          },
          {
            type: 'textheavy',
            video: true,
            url: './content/era4/ChangingSkylines.mp4',
            imagetype: 'square',
            title: 'CHANGING SKYLINES',
            text: 'Godrej had entered the hearts and homes of the Indian middle class with its wave of popular products, adapting constantly to the desires of the consumer. The national rhetoric was changing, and Godrej’s emphasis, too, was evolving. The sturdy, reliable everyman’s maker of locks and cupboards morphed into an aspirational brand making deodorant soaps and washing machines, endorsed by cinema stars. Technology and communication were the new drivers of progress. \n Some of Godrej’s businesses continued to grow and flourish, others were laid to rest. Real estate and architectural fabrication were added to the mix. Diversification was the order of the day: the small fridge, Chotukool, was as tremendous an achievement as working with the behemoth ISRO. Development and sustainability went hand in hand. The urban and the rural were both on the agenda, and global collaborations expanded horizons and processes. \n However, some things didn’t change. By contributing to the Indian Space Programme, doing charity through the Soonabai Pirojsha Godrej Foundation, protecting the mangroves in Vikhroli, consolidating employee welfare activities, and in developing products for the needy rural market, Godrej demonstrated its unwavering commitment to self-sufficiency, integrity, and the nation.',
            subtext: '',
            subsubtext: '',
            position: [-400, 45, -179],
          },

          {
            position: [-400, -2, 116],
            type: 'comic',
            url: './content/era4/ArchiFabCata.png',
            title: 'Catalogue of Architectural Fabrication',
            text: 'Circa 1970, Lalbaug Collection \n ACCN: CAT14-01-825-479',
          },
          {
            type: 'comic',
            url: './content/era4/AR5.png',
            position: [-194, 79, 400],
          },
        ],
      },
      {
        name: 'Aerospace',
        hr: './Godrej_archives_360_photos/HR/12-Closed.webp',
        lr: './Godrej_archives_360_photos/LR/12-Closed.webp',
        vlr: './Godrej_archives_360_photos/VLR/12-Closed.webp',
        lookAt: [-7.425, 0.377, 6.686],
        title: 'Esse labore amet deserunt esse ',
        text: 'Deserunt qui et est ullamco amet culpa deserunt quis. Cillum ipsum incididunt culpa est minim culpa non sit ullamco. Excepteur nulla eu amet sint. Commodo enim amet aliqua irure laborum nostrud eu dolor ipsum laborum aliquip officia laboris culpa.',
        hotspots: [
          {
            type: 'era',
            text: 'To 1940',
            era: 2,
            position: [175, -114, 30],
            rotation: [4.8, 0, 5.57],
            scale: 145,
          },

          {
            type: 'location',
            number: 1,
            position: [44, -93, 86],
            rotation: [1.51, 3.05, 7.14],
            scale: 85,
          },

          {
            type: 'comic',
            url: './content/era4/AeroTimeline.webp',
            position: [-400, 59, 360],
          },
          {
            type: 'comic',
            url: './content/era4/AR4.png',
            position: [39, -9, -400],
          },

          {
            position: [-295, 36, 400],
            type: 'audio',
            url: './content/era4/SMVaidyaInterview.mp3',
            title: 'S M Vaidya’s interaction with RJ Melbin',
            text: 'Here’s Dr. S M Vaidya, Executive Vice President, and Business Head, Godrej Aerospace, in conversation with RJ Melbin of 94.3 Radio One on Foundation Day, 07th May 2015. Melbin quizzes Vaidya about Godrej’s contribution to the PSLV.',
            subsubtext: 'ACCN: AV15-25-23-12',
          },
          {
            position: [349, -200, -400],
            type: 'audio',
            url: './content/era4/GKDatarInterview.wav',
            title: 'G K Datar’s interview',
            text: 'G K Datar, then Plant Manager, Godrej Process Equipment speaks about Godrej’s enhanced technical know-how and manufacturing capabilities that enabled them to take up the challenge of manufacturing in-house the Expander for the Vikas Engine supplied to Indian Space Research Organisation (ISRO) in 1991.',
            subsubtext: 'OH06007',
          },
          {
            type: 'textheavy',
            video: false,
            url: './content/era4/IceInVillage.webp',
            imagetype: 'portrait',
            title: 'ICE IN VILLAGES, FIRE IN THE STARS',
            subtitle: 'Godrej and ISRO', //this is there only in this era, check figma
            text: 'Dr. Vikram Sarabhai, the father of the Indian Space Programme, shared a fundamental philosophy with Godrej: that of self-reliance. His words uncannily echo those of Ardeshir Godrej when he says, “We do not wish to acquire black boxes from abroad but to grow a national capability.” In 1985, the Godrej Tool Room received an order from ISRO to manufacture satellite components. Impressed by the result, Professor U R Rao, Chairman of ISRO accepted Naval Godrej’s invitation to visit Vikhroli in 1987. In the same year, Naval Godrej visited the Mahendragiri test facilities at Trivandrum at the invitation of Prof. Rao. After a series of discussions with scientists, the first order for the manufacture of Vikas Liquid Propulsion engine for PSLV was finalised. \n The success of this transaction pumped up Godrej’s confidence in its capabilities, and made the transition from ‘thinking in feet to thinking in microns.’ It set in motion a long, fruitful association between Godrej and ISRO - an association that led to the emergence of several indigenous facilities. ISRO, in its publication ‘INDUSPACE’ 91/92 went on record saying that the Contour Nozzle facility consisting of the Push-type Hydraulic Expander of 800T capacity, totally designed and developed by Godrej & Boyce Mfg. Co. Ltd. was one of the biggest facilities to have been established in the country. The Rotary Vacuum Brazing Facility that was developed at Godrej around 1998 placed India among a select group of countries – along with Russia and China – to have such a facility. \n Today Godrej Aerospace has become an integral part of India’s space programme, including the prestigious Chandrayaan and Mangalyaan missions. Recently, it also played a significant role in ISRO’s successful launch of 104 satellites by manufacturing critical systems and components for the launch vehicle. The sky doesn’t seem to be the limit for Godrej Aerospace. ',
            subtext:
              'Letter from Naval Godrej to Professor U R Rao (the former Chairman, ISRO) inviting him \nto visit Godrej factory',
            subsubtext:
              '12 June 1987, Source: R Krishnan, Trivandrum branch \nACCN: MS08-07-13-11',
            position: [183, 76, -242],
          },
          {
            type: 'textheavy',
            video: false,
            url: './content/era4/ChotuKool.webp',
            imagetype: 'square',
            title: 'ICE IN VILLAGES, FIRE IN THE STARS',
            subtitle: 'ChotuKool', //this is there only in this era, check figma
            text: 'Innovation and research permeates every aspect of Godrej, big or small. On one hand, Godrej was helping India reach the stars, and on the other, it was turning its considerable energies towards improving the lives of people in rural India through the inventive technology of the Chotukool.This little device can cool food to 8 degrees, and works on electricity or a battery. It doesn’t have the usual compression system – instead it works on a solid state cooling system. Yet the price is so reasonable that a lower income household or a small entrepreneur can afford it. The product was co-created with the community, and its distribution and marketing is done by entrepreneurs from within the community itself. \nIn a country where food spoils fast and 80% of households have never owned a fridge, Chotukool has the power to transform lives.',
            subtext: '',
            subsubtext: '',
            position: [400, 3, -101],
          },

          {
            type: 'video',
            position: [-400, 122, -215],
            title: 'CHOTUKOOL',
            url: 'https://vimeo.com/655248652/f045e9aa89',
            text: 'How can you innovate to achieve inclusive growth? – An Innosight Impact Story featuring the Godrej Chotukool. \n 2012',
          },
          {
            type: 'video',
            position: [-294, 11, 137],
            title: 'MAKE IN INDIA',
            url: 'https://vimeo.com/655248581/5473874683',
            text: '‘Make in India: New Deal for Defence’ – Video telecast by CNBC, \n 24th March 2016. Source: Corporate Communications, Godrej & Boyce. \n ACCN: AV16-29-1-1 ',
          },
        ],
      },
    ],
  },
]
export const VideoRoom = [
  {
    title: 'GODREJ STORY FIRST CORPORATE FILM',
    image: './content/era4/videobooth/GodrejStoryFirst.png',
    // text:'testing',
    // url:'./content/era4/videobooth/GodrejStory.mp4',
    url: 'https://vimeo.com/655249873/aeda9792b8',
  },
  {
    title: 'CORPORATE FILM QUILT',
    image: './content/era4/videobooth/CorporateFilmQuilt.png',
    url: 'https://vimeo.com/655249582/29ea771d52',
  },
  {
    title: 'TVC : GODREJ STORWEL',
    image: './content/era4/videobooth/StorwelAds.png',
    url: 'https://vimeo.com/655249274/a2fa2a1f45',
  },
  {
    title: 'TVC : GODREJ SMART WASH',
    image: './content/era4/videobooth/SmartWash.png',
    url: 'https://vimeo.com/655248972/b0a0a502cf',
  },
  {
    title: 'TVC : PENTACOOL REFRIGERATOR',
    image: './content/era4/videobooth/PentacoolRefridgerator.png',
    url: 'https://vimeo.com/655248883/bc44b08f88',
  },
  {
    title: 'FREEDOM IS WHEN LIFE BOCOMES BRIGHTER',
    image: './content/era4/videobooth/FreedomIsWhen.png',
    url: 'https://vimeo.com/655249769/e2c9f993d5',
  },
  {
    title: 'TYPEWRITER BOOK LAUNCH',
    image: './content/era4/videobooth/TypwWriterBookLaunch.png',
    url: 'https://vimeo.com/655249371/3e3ad5f1c9',
  },
  {
    title: 'NAVAL PIROJSHA GODREJ',
    image: './content/era4/videobooth/NavalPirojshaGodrej.png',
    url: 'https://vimeo.com/655248796/a1c0662da7',
  },
]
export const Values = [
  {
    title: 'A NEW NATION',
    text: 'Ingrained in the lifeblood of Godrej was its founder’s unshakable belief that Swadeshi was all about self - reliance in manufacturing. Building indigenous products that could compete with the best in the world became a habit: typewriters, vaults, institutional furniture, and soaps especially made with vegetable oil. Facilitating democracy by fashioning unbreakable ballot boxes for India’s first election. Spurring on economic growth by harnessing technology, patenting stronger, lighter, more economical materials, leading to cheaper and better products for mass consumption (and which even replaced European goods in some government departments), and providing employment to thousands. Supporting infrastructure across more industries like defense and rural development by manufacturing satellite components and Liquid Propulsion Systems for ISRO or inventing the ingenious small fridge called Chotukool for rural areas. ',
    image: './content/values/value1.jpg',
  },
  {
    title: 'A people Culture',
    text: 'At the heart of Godrej lies a deep obligation to its people. Those who work at Godrej, and the communities they are linked to; those whom Godrej serves as customers; and carrying on the philanthropic ideals of the founder, to charitable endeavours. And of course, servicing the needs of a middle class eager for a better quality of life through well priced, high-quality products. Pirojsha Godrej believed that happier employees would directly impact productivity. He brought in sweeping welfare measures for the labour force at all their plants in India and Malaysia. His incredible commitment to his people led to the industrial township at Vikhroli. Employees could live in safer, cleaner housing and their children could go to the Udayachal School in the premises at a subsidised fee. At the community space, which they called Pragati Kendra, their wives could learn to read, or attend talks that educated them on family planning, nutrition and hygiene. They could play sports or enjoy the abundant green environs. Their holistic wellbeing at the workplace and beyond was a serious responsibility undertaken by Godrej, and that idea carries through to this day.',
    image: './content/values/value2.jpg',
  },
  {
    title: 'a sustainable environment',
    text: 'Today, it is said that the lungs of Mumbai are its mangroves. Substantial credit for preserving these bountiful species in the area must go to Godrej. The Vikhroli settlement was conceived as a healthy, green space for employees and its sobriquet ‘the garden industrial township’ is well deserved. It is said that the trees were planted before the first factory shed was ever built. Going beyond this, Godrej over the years, has absorbed sustainable practices into every aspect of its working and are often referred to as “Mumbai’s first green family". ',
    image: './content/values/value3.jpg',
  },
  {
    title: 'AN OBSESSION WITH QUALITY',
    text: 'Extraordinary craftsmanship and robust engineering are hallmarks of Godrej products. Staving off fierce competition from foreign-made goods wouldn’t have been possible otherwise for A B Godrej and his Swadeshi ideals. That high standard percolated to every design, every prototype and every product made by the company. Safes that survived wars and explosions; soaps that respected religious beliefs; typewriters with intricate working that gave the Remingtons of the world something to think about; cupboards that altered the meaning of security for the Indian home; and Godrej’s contribution to the Indian Space Program. The accolades and awards flowed in, but were secondary to the loyal brand following of a million households because of the sheer accessibility of the products. Godrej was even invited to associate with the Indian Standard Association (ISI) to help set standards for the industry.',
    image: './content/values/value4.jpg',
  },
  {
    title: 'A DOCTRINE OF SELF-SUFFICIENCY',
    text: "Swadeshi meant more than just boycotting imported goods to A B Godrej. A true patriot, he acted on his conviction and strived to create economic independence in support of the country’s political freedom. Self-sufficiency equalled self-respect in his book. So, it was no surprise then, that within the company too, self-reliance was an enshrined value. Manufacturing wasn't just for products to be sold in the market; it was also geared towards feeding internal needs. Making of forklift trucks and their attachments was one such major effort. The other was the Godrej Tool Room, which allowed easy availability of scarce machine availability during the war, and thereafter the thrust towards self-contained operations. It is no wonder the archives celebrate the machine aesthetic of the remarkable company called Godrej. ",
    image: './content/values/value5.jpg',
  },
]

let creds = [
  'Godrej Archives Team\nVrunda Pathare, Sudha Sawant, Harini Alladi, Amruta Marathe, Kishor Vaity, Tushar Kansara, Jaymala Mandvikar, Rafik Sheikh, Vishnu and Hanumanta',
  'Curation and Design\nwww.hanno.inTeam: Sarita Sundar, Georgie Paul, Priyanka Borar, Savithri M, Ruchika Chanana',
  'Exhibition Fabrication\nJumana Seth, Shrikant Amin, Ashif ShaikhThe Urbane Design Company',
  'Thanks to\nGodrej Construction, Godrej E&E team, Godrej Process Equipment, Godrej Security Solutions, Godrej Locks, Godrej Appliances, Godrej Aerospace, Godrej Material Handling and Godrej Consumer Products Ltd for their support',
  'Godrej Construction Team\nManeck Engineer, Anup Matthew, Dilip Kamlapurkar, Vishal Maheshwari, Devidas Mandrekar, Aarti Bhambore, Prasad Vavikar, Nitin Chavan',
  'Godrej E&E team\nKunjal Shah, Vikram Kesari, Suhas, Shailesh Shanbag, Sanjay Jawle, Uttam Ganguly, Prashant Babar,Pravin Rawool',
  'Godrej Process Equipment Team\nKulothungan Ramaswamy, Sunil Parab,Rajas Jadhav',
  'Godrej Security Solutions Team\nSwapneel Nagarkar, Prashant C,Jayesh Patel, Kashiram Sawant,Rahim',
  'Godrej Locks\nSadanand Pawar',
  'Godrej Appliances Team\nGaurav Chopra, Sanjay Lonial, Sanket Baing,Shakeel Jamadar, Pushkar Warkhedkar',
  'Godrej Aerospace\nRamesh Kumar Sankarannai',
  'Godrej Material Handling Team\nSarosh Doomasia',
  'Godrej Procurement team\nPooja Chavan',
  'Godrej P&A\nPrakash Ghadigaonkar',
  'Safety Department\nPrasheel Sawant',
  'Team Security\nDeepak Kadam, Sujit Dahale, Deepak Patha',
  'Godrej Consumer Products Ltd\nSandeep Naik',
  'Team Godrej\n Vrunda Pathare, Shweta Jadhav, Sudha Sawant, Soumya Bhave, Kishor Vaity, Tushar Kansara',
  '\nBismita Nayak, Balkrushna Dhondage, Kalpesh Patel',
  '\nAnupriya Kulkarni Sandeep Rana, Nilakshi Bandodkar, Gayatri Sawardekar, Sakshi Agarkhed, Vishal Gosavi, Tejaswini Kadam',
  '\nNalini Kala, Elizabeth Bocarro',
  'Team AutoVRse\nAnuj Gupta, Sahil Singh, Jobin Varghese, Ajayan Radhakrishnan, Joby Simon, Shreya Pidikiti, Nidheesh Boban, Vivek Sreedhar, Angad Raghavan, Vishal Ahankari ',
]
export const credits = {
  titles: creds.map((x) => x.split('\n')[0]),
  texts: creds.map((x) => x.split('\n')[1]),
}

export const flattenedLocations = flattenLocations(AllMuseumLocations)
